import { HttpContextToken } from '@angular/common/http';

/** Prevents the refresh interceptor from trying to refresh the refresh request itself. */
export const SKIP_AUTH_REFRESH = new HttpContextToken<boolean>(() => false);
